/** Remove as repetições de `char` nas duas pontas de `input` (ex.: `trimChar('//a/b//', '/')` → `'a/b'`). */
export function trimChar(input: string, char: string): string {
  let start = 0;
  let end = input.length;
  while (start < end && input.charAt(start) === char) {
    start++;
  }
  while (end > start && input.charAt(end - 1) === char) {
    end--;
  }
  return input.substring(start, end);
}
